import {DataTable} from "../DataTable/DataTable";
import {CompanySettlementEntity} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {Anchor, Group} from "@mantine/core";
import {useDataTableSorter} from "../DataTable/useDataTableSorter";
import {usePagination} from "../DataTable/usePagination";
import {useCompanySettlementDataTableFilter} from "./useCompanySettlementDataTableFilter";
import {getColumnFilterProps} from "../DataTable/useDataTableFilter";
import {EntityDataTableProps} from "../EntityDataTable/EntityDataTable";
import {FormattedDatabaseCode} from "../../text/FormattedDatabaseCode/FormattedDatabaseCode"
import {DefaultText} from "../../text/DefaultText/DefaultText";
import {Link} from "react-router-dom";

const EMPTY_ARRAY: CompanySettlementEntity[] = []

export type CompanySettlementDataTableProps = EntityDataTableProps<CompanySettlementEntity>

export const CompanySettlementDataTable = (props: CompanySettlementDataTableProps) => {
  const {
    records: companySettlements = EMPTY_ARRAY,
    recordsPerPageOptions,
    ...rest
  } = props;

  const {t} = useTranslation(["common"]);

  const {filteredRecords, filterConfig} = useCompanySettlementDataTableFilter({
    records: companySettlements
  })

  const {
    sortedRecords,
    sortStatus,
    onSortStatusChange,
  } = useDataTableSorter({
    records: filteredRecords,
    sortStatus: {columnAccessor: 'company', direction: 'asc'}
  })

  const pagination = usePagination({
    data: sortedRecords,
    recordsPerPageOptions: recordsPerPageOptions,
  });

  return (
    <DataTable
      {...rest}
      {...(pagination ?? {})}
      sortStatus={sortStatus}
      onSortStatusChange={onSortStatusChange}
      columns={[
        {
          ...getColumnFilterProps(filterConfig, "company"),
          title: t("common.entity.table.companysettlement.column.company", "Company"),
          accessor: "company",
          width: 100,
          sortable: true,
          render: (record) => {
            return (
              <Anchor component={Link} to={`company/profile?id=${record.id}`}>
                <DefaultText value={record.companyName}/>
              </Anchor>
            )
          },
        },
        {
          ...getColumnFilterProps(filterConfig, "method"),
          title: t("common.entity.table.companysettlement.column.method", "Method"),
          accessor: "method.code",
          width: 100,
          sortable: true,
          render: ({method}) => (
            <FormattedDatabaseCode value={method}/>
          ),
        },
        {
          ...getColumnFilterProps(filterConfig, "name"),
          title: t("common.entity.table.companysettlement.column.name", "Name"),
          accessor: "name",
          width: 100,
          sortable: true,
        },
        {
          ...getColumnFilterProps(filterConfig, "status"),
          title: t("common.entity.table.companysettlement.column.status", "Status"),
          accessor: "status.code",
          width: 100,
          sortable: true,
          render: ({status}) => (
            <FormattedDatabaseCode value={status}/>
          ),
        },
        {
          title: '',
          accessor: 'actions',
          width: 50,
          render: (record) => {
            return (
              <Group spacing={4} position="right" noWrap>

              </Group>
            )
          }
        }
      ]}
    />
  );
};
